import { gql, useMutation } from '@apollo/client';

export const UPDATE_CART_ITEM_QUANTITY = gql`
  mutation updateCartItemQuantity($productId: String!, $quantity: Int!) {
    cart {
      updateCartItemQuantity(productId: $productId, quantity: $quantity) {
        success
      }
    }
  }
`;

export default function useUpdateCartItemQuantity() {
  const [
    updateCartItemQuantityMutation,
    { data, loading: isUpdateCartItemQuantityLoading, error: updateCartItemQuantityError },
  ] = useMutation(UPDATE_CART_ITEM_QUANTITY, {
    errorPolicy: 'all',
  });
  const createUpdateCartItemQuantityMutation = (productId :any, quantity :any)  => {
    updateCartItemQuantityMutation({
      variables: {
        productId: productId,
        quantity: quantity,
      },
    });
  };

  return {
    createUpdateCartItemQuantityMutation,
    updateCartItemQuantityData: data,
    isUpdateCartItemQuantityLoading,
    updateCartItemQuantityError,
  };
}
